<ng-container
  *ngTemplateOutlet="
    variant;
    context: { value: orderUserProfileFilter.ALL, title: '<span>все </span> <span> заказы </span>' }
  "
></ng-container>
<ng-container
  *ngTemplateOutlet="
    variant;
    context: { value: orderUserProfileFilter.B2C, title: '<span> заказы </span> <span> на физ. лицо </span>' }
  "
></ng-container>
<ng-container
  *ngTemplateOutlet="
    variant;
    context: { value: orderUserProfileFilter.B2B, title: '<span> заказы </span> <span> на юр. лицо </span>' }
  "
></ng-container>

<ng-template let-value="value" let-title="title" #variant>
  <button
    sdButton
    radius="l"
    class="btn-filter"
    [class.chosen]="value === (selectedFilterValue$ | async)"
    size="s"
    (click)="onClickFilter(value)"
  >
    <span class="title" [innerHTML]="title"></span>
  </button>
</ng-template>
